module.exports = __webpack_public_path__ + "img/placeholder-hehe.b069f019.png";